import {
  //
  ADD_PAGES,
  ADD_PAGES_FAILURE,
  ADD_PAGES_SUCCESS,
  //
  DELETE_PAGES,
  DELETE_PAGES_FAILURE,
  DELETE_PAGES_SUCCESS,
  //
  EDIT_PAGES,
  EDIT_PAGES_FAILURE,
  EDIT_PAGES_SUCCESS,
  //
  FETCH_PAGES,
  FETCH_PAGES_FAILURE,
  FETCH_PAGES_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  OPEN_PAGES_ADD_MODAL,
  CLOSE_PAGES_ADD_MODAL,
  //
  OPEN_PAGES_EDIT_MODAL,
  CLOSE_PAGES_EDIT_MODAL,
  //
  TOGGLE_ITEM_MODAL,
  TOGGLE_SECTION_MODAL,
  TOGGLE_INNER_SECTION_MODAL,
  TOGGLE_INNER_ITEM_MODAL,
  //
  UPLOAD_FILE,
  UPLOAD_FILE_FAILURE,
  UPLOAD_FILE_SUCCESS,
} from "./constants";

// List
export const fetchPages = (payload) => ({
  type: FETCH_PAGES,
  payload,
});
export const fetchPagesSuccess = (payload) => ({
  type: FETCH_PAGES_SUCCESS,
  payload,
});
export const fetchPagesFailure = (payload) => ({
  type: FETCH_PAGES_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addPages = (payload) => ({
  type: ADD_PAGES,
  payload,
});
export const addPagesSuccess = (payload) => ({
  type: ADD_PAGES_SUCCESS,
  payload,
});
export const addPagesFailure = (payload) => ({
  type: ADD_PAGES_FAILURE,
  payload,
});
// EDIT
export const editPages = (payload) => ({
  type: EDIT_PAGES,
  payload,
});
export const editPagesSuccess = (payload) => ({
  type: EDIT_PAGES_SUCCESS,
  payload,
});
export const editPagesFailure = (payload) => ({
  type: EDIT_PAGES_FAILURE,
  payload,
});
// DELETE
export const deletePages = (payload) => ({
  type: DELETE_PAGES,
  payload,
});
export const deletePagesSuccess = (payload) => ({
  type: DELETE_PAGES_SUCCESS,
  payload,
});
export const deletePagesFailure = (payload) => ({
  type: DELETE_PAGES_FAILURE,
  payload,
});

export const openPagesAddModal = (payload) => ({
  type: OPEN_PAGES_ADD_MODAL,
  payload,
});
export const closePagesAddModal = (payload) => ({
  type: CLOSE_PAGES_ADD_MODAL,
  payload,
});

export const openPagesEditModal = (payload) => ({
  type: OPEN_PAGES_EDIT_MODAL,
  payload,
});
export const closePagesEditModal = (payload) => ({
  type: CLOSE_PAGES_EDIT_MODAL,
  payload,
});
//
export const toggleItemModal = (payload) => ({
  type: TOGGLE_ITEM_MODAL,
  payload,
});
export const toggleSectionModal = (payload) => ({
  type: TOGGLE_SECTION_MODAL,
  payload,
});
export const toggleInnerSectionModal = (payload) => ({
  type: TOGGLE_INNER_SECTION_MODAL,
  payload,
});
export const toggleInnerItemModal = (payload) => ({
  type: TOGGLE_INNER_ITEM_MODAL,
  payload,
});
//
export const uploadFile = (payload, onUploadSuccess) => ({
  type: UPLOAD_FILE,
  payload,
  onUploadSuccess,
});
export const uploadFileSuccess = (payload) => ({
  type: UPLOAD_FILE_SUCCESS,
  payload,
});
export const uploadFileFailure = (payload) => ({
  type: UPLOAD_FILE_FAILURE,
  payload,
});
